import { apiOrganization } from "src/services/Api/Organization/apiOrganization";
import { ArchivesStatus } from "src/services/Api/Organization/types";
import { delay } from "go-core";

export const getArchiveInfoStatus = async (archiveId: number) => {
	const { status } = await apiOrganization.getArchiveInfo(archiveId);
	return status;
};

export const waitForArchiveStatusChange = async (
	archiveId: number,
	endLoopCallback: (updatedStatus: ArchivesStatus) => boolean
) => {
	let shouldGetArchiveInfo = true;
	while (shouldGetArchiveInfo) {
		const status = await getArchiveInfoStatus(archiveId);
		if (endLoopCallback(status)) {
			shouldGetArchiveInfo = false;
			return status;
		}

		await delay(2000);
	}
};
